//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import ProductNotify from "@/components/ProductNotify";
import Slick from "vue-slick";

export default {
  name: "Product_detail",
  components: {
    ProductNotify,
    Slick,
  },
  head() {
    return {
      bodyAttrs: {
        class: "w-store product-detailmain",
      },
      title: `Buy ${this.name} Online | Walkway Shoes`,
      meta: [
        {
          hid: "description",
          name: "description",
          content: `This pair of Walkway ${this.name} weds classic
           good looks with absolute comfort. Make a value-for-money addition to your footwear collection. Shop now!`,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: `Buy ${this.name} Online | Walkway Shoes`,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: this.$store.state.list.base_Url + this.$route.path,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: "https://walkwayshoes.com/images-walk/logo.png",
        },
        {
          hid: "og:image-width",
          property: "og:image-width",
          content: "200",
        },
        { hid: "og:image-height", content: "200" },
        {
          hid: "og:description",
          property: "og:description",
          content: `This pair of Walkway ${this.name} weds classic
           good looks with absolute comfort. Make a value-for-money addition to your footwear collection. Shop now!`,
        },
        { hid: "keywords", property: "keywords", content: this.meta_keyword },
        {
          property: "keywords",
          content: this.meta_keyword,
        },
        {
          name: "twitter:site",
          content: "@Walkway",
        },
        {
          name: "twitter:title",
          content: `Buy ${this.name} Online | Walkway Shoes`,
        },
        {
          name: "twitter:description",
          content:`This pair of Walkway ${this.name} weds classic
           good looks with absolute comfort. Make a value-for-money addition to your footwear collection. Shop now!`,
        },
        {
          name: "twitter:image",
          content: "https://walkwayshoes.com/images-walk/logo.png",
        },
        {
          name: "twitter:app:country",
          content: "IN",
        },
        {
          name: "twitter:app:name:iphone",
          content: "Walkway",
        },
        {
          name: "twitter:app:url:iphone",
          content: this.$store.state.list.base_Url + this.$route.path,
        },
        {
          name: "twitter:app:name:googleplay",
          content: "Walkway",
        },
        {
          name: "twitter:app:url:googleplay",
          content: this.$store.state.list.base_Url + this.$route.path,
        },
        {
          name: "twitter:app:id:googleplay",
          content: "com.walkway.android",
        },
      ],
      script: [
        {
          json: [
          this.$store.state.list.breadCrumbArray && this.$store.state.list.breadCrumbArray.length > 0 ?
          {
            "@context": "http://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": this.$store.state.list.breadCrumbArray.map((item, index) => {
                return {
                  "@type": "ListItem",
                  "position": index + 1,
                  "name": item.name,
                  "item": item.url
                }
              })
            } : {},
            {
              "@context": "https://schema.org/",
              "@type": "Product",
              "name": this.name,
              "url": `https://walkwayshoes.com/product/${this.productURLkey}`,
              "image":`https://admin.walkwayshoes.com/product/17-14/1080/${this.placeholder_image}`,
              "description": this.description,
              "brand": {
                "@type": "Brand",
                "name": this.brand
              },
              "color": this.productColor,
              "offers": {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": this.selling_price,
                "availability": `https://schema.org/${this.stock_status}`
              }
            }
          ],
          type: "application/ld+json",
        },
      ],
    };
  },
  // metaInfo () {
  //     return {
  //         bodyAttrs: {
  //         class: 'w-store product-detailmain'
  //         },
  //         title: this.meta_title,
  //             meta: [
  //                {     hid: 'description',
  //                     name: 'description',
  //                     content: this.meta_description
  //                 },
  //                 {
  //                     property: 'keywords',
  //                     content: this.meta_keyword
  //                 }
  //             ],
  //             link:[
  //                 {
  //                     rel:"canonical",
  //                     href:"https://"+location.host+this.$route.fullPath
  //                 }
  //             ]
  //     }
  // },

  data: function () {
    return {
      size_label: "",
      coupon_list: [],
      wishDatapr: false,
      offer_list_popup: false,
      similarslickoptions: {
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      },
      vueslickOptions: {
        dots: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      similarproducts: "",
      apifilter: "",
      pintickbox: false,
      measureshoe: true,
      shareImage: "",
      limit_by: 3,
      star: null,
      customer_name: null,
      title: null,
      customer_complain: null,
      name_of_manufacturer: null,
      marketer_details: null,
      manufacturer_name_address: null,
      customer_description: null,
      callLightgallery: false,
      galleryImages: [],
      galleryIndex: null,
      gender: "Men",
      activeEMIClass: "",
      emiPlans: {},
      bankPlans: {
        minAmount: 0,
        plans: { 3: 14, 6: 14, 9: 14, 12: 14, 18: 14, 24: 14 },
      },
      showEMIPopup: false,
      tableContent: "",
      careInsTab: false,
      productDeatil: false,
      returnTab: false,
      complaintab: false,
      importerTab: false,
      acces_return: false,
      sale: "",
      rating: {
        star: "",
        review: "",
        title: "",
      },
      reviews: {
        reviews: [],
      },
      brand: "",
      productURLkey: "",
      sizechartDetails: [],
      sizechartlabel: [],
      slickOptions: {
        slidesToShow: 1,
        lazyLoad: "ondemand",
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        fade: false,
        asNavFor: ".slick-thumb",
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
            },
          },
        ],
      },
      slickOptionsDesktop: {
        slidesToShow: 1,
        lazyLoad: "ondemand",
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        fade: false,
        asNavFor: ".slick-thumb",
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
            },
          },
        ],
      },
      slickOptions1: {
        lazyLoad: "ondemand",
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: ".main-slider",
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
      },
      slickOptionsDesktop1: {
        lazyLoad: "ondemand",
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: ".main-slider",
        arrows: false,
        infinite: false,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
      },
      slickOptions3: {
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 997,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "50px",
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              centerMode: false,
              // centerPadding: '50px'
            },
          },
        ],
        // Any other options that can be got from plugin documentation
      },
      size: {
        select_size: "",
        max_qty: "1",
        variant_id: "",
        sku: "",
      },
      product_attr_data: {
        count: 4,
        text: "Show More",
        active: false,
      },
      wishlist: [],
      // meta_title: "",
      productColor: "",
      // meta_description: "",
      meta_keyword: "",
      size_active: true,
      qty: "1",
      size_error: "",
      pro_id: this.$route.params.pro_id,
      pro_url_key: this.$route.params.product,
      name: "",
      master_sku: "",
      sub_group_id: "",
      price: 0,
      stock_status: "",
      product_cat: "",
      selling_price: 0,
      quantity: 0,
      description: "",
      variation: [],
      clicked: false,
      color_options: [],
      placeholder_image: "",
      gallery: [],
      is_discount: "",
      offers_list: "",
      product_attr: [],
      couponoffers: [],
      productFeatuers: {},
      productStyleTip: '',
      show_hide_product_attr: [],
      show_hide_product_attr_type: false,
      team_up_products: [],
      size_guide: "",
      size_chart_content: "",
      size_guide_popup: false,
      size_guide_type: "IN",
      pincode: "",
      pincode_success: "",
      cod_available: "",
      //pincode_success: '<span class="span1">Free delivery on all orders above Rs '+ this.$store.state.list.shipping_charges_below +'. COD charge Rs '+ this.$store.state.list.cod_charges +'.</span><span class="span4">Easy Return within 15 days.</span>',
      pincode_error: "",
      proNetQuantity: '',
      proDimenstion: '',
      networks: [
        //{ network: 'facebook', name: 'Facebook', icon: 'fa fa-facebook-f', color: '#1877f2' },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fa fa-whatsapp",
          color: "#25d366",
        },
        //{ network: 'pinterest', name: 'Pinterest', icon: 'fa fa-pinterest', color: '#bd081c' },
      ],
    };
  },
  methods: {
    async getCasaProductView() {
      var form = new URLSearchParams();
      form.append("store", 1);
      form.append("id_product", this.$store.state.list.pro_id_store);
      form.append("track_id", localStorage.getItem("xCasaTrackerId"));
      if (this.$store.state.list.customer_session) {
        form.append("customer_id", this.$store.state.list.customer_id);
        form.append(
          "customer_session",
          this.$store.state.list.customer_session
        );
      }
      await axios
        .post(this.$store.state.list.cart_api_url + "/casa/product-view", form)
        .then((response) => {
          console.log("get casa product view data push");
        });
    },
    get_add_to_cart(order_quote_id) {
      var form = new URLSearchParams();
      form.append("store", 1);
      form.append("order_quote_id", order_quote_id);
      form.append("track_id", localStorage.getItem("xCasaTrackerId"));
      if (this.$store.state.list.customer_session) {
        form.append("customer_id", this.$store.state.list.customer_id);
        form.append(
          "customer_session",
          this.$store.state.list.customer_session
        );
      }
      axios
        .post(this.$store.state.list.cart_api_url + "/casa/add-to-cart", form)
        .then((response) => {
          console.log("get casa add to cart data push");
        });
    },
    variationId() {
      for (let unitwish of this.$store.state.list.wishlist) {
        if (unitwish === this.pro_id) {
          this.wishDatapr = true;
          break;
        } else {
          this.wishDatapr = false;
        }
      }
    },
    closeOffer_list_popup() {
      this.offer_list_popup = false;
    },
    coupon_lists() {
      axios
        .get(this.$store.state.list.api_url + `/pim/promotions/listapi.php`)
        .then((response) => {
          this.coupon_list = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    similarproduct() {
      axios
        .get(this.$store.state.list.api_url + `/pim/pimresponse.php/`, {
          params: {
            service: "category",
            store: this.$store.state.list.store,
            url_key: "women-casual",
            page: 1,
            count: 10,
            sort_by: "sku_rank",
            sort_dir: "desc",
            filter: this.apifilter,
          },
        })
        .then((response) => {
          this.similarproducts = response.data.result.products;
        })
        .catch((error) => {
          console.log("error in api data", error);
        });
    },
    showmeasure() {
      this.measureshoe = false;
    },
    showdetail() {
      this.measureshoe = true;
    },
    simple_toggle(param1, param2) {
      param1 < param2 ? (this.limit_by = param2) : (this.limit_by = 3);
      return;
    },
    SchemaReview(param) {
      var newSchema = [...param];
      newSchema.length = 1;
      return newSchema.map((item, index) => {
        return {
          "@type": "Review",
          reviewRating: {
            "@type": "Rating",
            ratingValue: item.rr_rating,
          },
          author: {
            "@type": "Person",
            name: item.rr_customer_name,
          },
          reviewBody: item.rr_description,
        };
      });
    },
    gtm_product_click: function (
      name,
      brand,
      sub_group_id,
      id,
      price,
      category,
      position
    ) {
      this.$gtm.push({
        event: "productClick",
        action: "productClick",
        label: "list",
        ecommerce: {
          click: {
            actionField: {
              list: "list",
              action: "click",
            },
            product: [
              {
                name: name,
                id: id,
                price: price,
                category: category,
                position: position + 1,
              },
            ],
          },
        },
      });
      this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
      this.$gtm.push({
        event: "select_item",
        ecommerce: {
          items: [
            {
              item_id: sub_group_id,
              item_subGId: sub_group_id,
              item_name: name,
              index: position,
              item_productId: id,
              item_brand: brand,
              item_category: category,
              price: price,
            },
          ],
        },
      });
    },

    EMIVal2(loan, interestRate, time) {
      // var monthlyInterestRatio = (parseFloat(interestRate)/100)/12;

      // var top = Math.pow((1+monthlyInterestRatio), parseInt(time));
      // var bottom = top -1;
      // var sp = top / bottom;
      // var emi = ((parseInt(loan) * monthlyInterestRatio) * sp)
      // var totalAmount = emi * parseInt(time)
      // var interestPM =( totalAmount - loan)/ parseInt(time)
      // return {emi:emi,total: totalAmount, interestPM:interestPM}
      let interest = parseFloat(interestRate) / 1200;
      let term = parseInt(time);
      let top = Math.pow(1 + interest, term);
      let bottom = top - 1;
      let ratio = top / bottom;
      let emi = parseInt(loan) * interest * ratio;
      var totalAmount = emi * term;
      var interestAmount = totalAmount - parseInt(loan);
      return { emi: emi, total: totalAmount, interestAmount: interestAmount };
    },
    showHealType(item) {
      if (
        (this.gender === "Men" || this.gender === "men") &&
        item.label === "Heel Type"
      ) {
        return false;
      } else {
        return true;
      }
    },
    reviewRating(item) {
      item = parseInt(item);
      var arr = [];

      for (var i = 1; i <= item; i++) {
        arr.push(i);
      }

      return arr;
    },
    selectProduct(article) {
      this.pro_id = article.id_product;
      this.master_sku = article.sku;
      this.price = article.price;
      // this.qty = article.quantity
      this.selling_price = article.selling_price;
    },
    getEmiPlansTableData(bank) {
      this.activeEMIClass = bank;
      this.bankPlans = {};
      this.bankPlans.plans = this.emiPlans[bank].plans;
      this.bankPlans.minAmount = this.emiPlans[bank].min_amount;
      // return plans
    },
    vibrate() {
      // alert('hi')
      window.navigator.vibrate(200);
    },
    async get_review() {
      var form = new FormData();
      form.append("store", 1);
      form.append("master_sku", this.master_sku);
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      this.$store.state.list.page_loader = true;
      await axios
        .post(
          this.$store.state.list.cart_api_url + "/review/review-list",
          form,
          config
        )
        .then((response) => {
          if (response.data.success == true) {
            this.reviews = response.data.data;
            (this.reviews.average_rating =
              this.reviews.average_rating.toString()),
              (this.reviews.total_review =
                this.reviews.total_review.toString()),
              (this.$store.state.list.page_loader = false);
            if (this.pincode_success === "") {
              this.pincode_success = "";
            }
          }
        });
    },
    close_popup_emi() {
      this.showEMIPopup = false;
    },
    emiOptions() {
      this.showEMIPopup = true;
      if (Object.keys(this.emiPlans).length === 0) {
        axios
          .get(this.$store.state.list.cart_api_url + "/payment/emi-options")
          .then((response) => {
            if (response) {
              this.emiPlans = response.data.data.emi_plans;
              this.getEmiPlansTableData(Object.keys(this.emiPlans)[0]);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    customer_review(e) {
      e.preventDefault();
      if (this.star != null && this.customer_name != "") {
        let isLogin = '/review/add-guest-review'
        var form = new FormData();
        if (
          this.$store.state.list.customer_id != null &&
          this.$store.state.list.customer_id != ""
        ) {
          isLogin = '/review/add-review'
          form.append("customer_id", this.$store.state.list.customer_id);
          form.append("customer_session", this.$store.state.list.customer_session)
        }
        form.append("product_id", this.pro_id);
        form.append("master_sku", this.master_sku);
        form.append("title", this.title);
        form.append("description", this.customer_description);
        form.append("customer_name", this.customer_name);
        form.append("rating", this.star);
        form.append("store", 1);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        axios
          .post(
            this.$store.state.list.cart_api_url + isLogin,
            form,
            config
          )
          .then((response) => {
            if (response.data.success == true) {
              this.$toast.success(response.data.message, {
                position: "top",
                duration: 4000,
              });
              this.title = "";
              this.star = "";
              this.customer_description = "";
              this.customer_name = "";
            } else {
              this.$toast.error(response.data.message, {
                position: "top",
                duration: 4000,
              });
            }
          });
      } else {
        this.$store.state.list.login_popup = true;
      }
    },
    product_attr_show_hide() {
      if (this.product_attr_data.active == false) {
        this.product_attr_data.count = this.product_attr.length;
        this.product_attr_data.active = true;
        this.product_attr_data.text = "Hide More";
        this.show_hide_product_attr_type = true;
      } else {
        this.product_attr_data.count = 4;
        this.product_attr_data.active = false;
        this.product_attr_data.text = "Show More";
        this.show_hide_product_attr_type = false;
      }
    },
    more_info_show: function () {
      this.show_hide_product_attr_type = true;
    },
    more_info_hide: function () {
      this.show_hide_product_attr_type = false;
    },
    pin_code: function () {
      let pincode = /^([0-9]{6,})+$/;
      if (this.pincode.match(pincode)) {
        axios
          .get(this.$store.state.list.api_url + `/pim/pimresponse.php/`, {
            params: {
              service: "pincheck",
              store: this.$store.state.list.store,
              pincode: this.pincode,
            },
          })
          .then((response) => {
            if (response.data.response.success === "1") {
              this.pincode_success = response.data.result.delivery;
              this.cod_available = response.data.result.cod;
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_pin",
                this.pincode
              );
              this.pincode_error = "";
              this.pintickbox = true;
            } else {
              this.pincode_error = response.data.response.error_message;
              this.pintickbox = false;
              this.pincode_success = "";
              this.cod_available = "";
            }
          });
      } else {
        this.pincode_error =
          "<span class='error'>Please enter valid Pin code</span>";
        this.pincode_success = "";
        this.cod_available = "";
        this.pintickbox = false;
      }
    },
    size_guide_con(type) {
      this.size_guide_type = type;
      // let size_val = document.getElementsByClassName("size-changetd");
      // for (let i = 0; i < size_val.length; i++) {
      //     if (type === 'CM') {
      //         let cur_size = (size_val[i].innerHTML * 2.54).toFixed(2);
      //         size_val[i].innerHTML = cur_size;
      //     }
      //     else {
      //         let cur_size = (size_val[i].innerHTML / 2.54).toFixed(0);
      //         size_val[i].innerHTML = cur_size;
      //     }
      // }
    },
    qty_plus() {
      if (this.size.select_size != "") {
        this.$store.state.list.error_message = "";
        this.$store.state.list.success_message = "";
        if (this.qty < this.size.max_qty && this.qty < 5) {
          this.qty = this.qty * 1 + 1;
        }
      } else {
        this.size_active = false;
        this.size_error = "Please select a size first";
        this.vibrate();

        if (window.innerWidth > 767) {
          this.$toast.error("Please select a size first.", {
            position: "top",
            duration: 4000,
          });
        }
      }
    },
    qty_minus() {
      if (this.size.select_size != "") {
        this.$store.state.list.error_message = "";
        this.$store.state.list.success_message = "";
        if (this.qty > 1) {
          this.qty = this.qty * 1 - 1;
        }
      } else {
        this.size_active = false;
        this.size_error = "Please select a size first";
        this.vibrate();
        this.$toast.error("Please select a size first.", {
          position: "top",
          duration: 4000,
        });
      }
    },
    sizeChart() {
      var url_key;
      switch (this.size_guide) {
        case "Size_Chart_LT":
          url_key = "size_chart_women";
          break;

        case "Size_Chart_GT":
          url_key = "size_chart_men";
          break;
        case "Size_Chart_AC":
          url_key = "size_chart_belt";
          break;
        case "Size_Chart_Wsocks": 
          url_key = "women_shocks_sizechart";
          break;
        case "Size_Chart_Msocks": 
          url_key = "men_socks_sizechart";
          break;
        default:
          url_key = "size_chart_kids";
      }
      this.$store.state.list.page_loader = true;
      axios
        .get(this.$store.state.list.api_url + `/pim/pimresponse.php/`, {
          params: {
            service: "cms_page",
            store: this.$store.state.list.store,
            url_key: url_key,
          },
        })
        .then((response) => {
          this.$store.state.list.page_loader = false;
          if (response.data.response.success === 1) {
            // this.sizechartDetails = response.data.result;
            // this.sizechartlabel = response.data.result[0].size_chart;
            this.tableContent = response.data.result[0].content;
            if (this.tableContent) {
              this.size_popup_show();
            }
          } else {
            this.$toast.error(response.data.response.error_message, {
              position: "top",
              duration: 4000,
            });
          }
        })
        .catch((error) => {
          this.$store.state.list.page_loader = false;
          if (error.message === "Network Error") {
            this.$toast.error(
              "Oops there seems to be some Network issue, please try again.",
              {
                position: "top",
                duration: 4000,
              }
            );
          }
        });
    },
    size_popup_show() {
      this.size_guide_popup = true;
      document.body.style.overflow = "hidden";
    },
    close_popup() {
      this.size_guide_popup = false;
      document.body.style.overflow = "auto";
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    async getprodetail(param1) {
      this.$store.state.list.breadCrumbArray = [];
      this.$store.state.list.error_message = "";
      this.$store.state.list.success_message = "";
      this.$store.state.list.page_loader = true;
      await axios
        .get(this.$store.state.list.api_url + `/pim/pimresponse.php/`, {
          params: {
            service: "product",
            store: this.$store.state.list.store,
            //id_product:this.pro_id,
            url_key: this.pro_url_key,
          },
        })
        .then(async (response) => {
          if (response.data.response.success === 1) {
            this.$store.state.list.breadCrumbArray = JSON.parse(
              response.data.result.breadcrumb
            );
            this.size_label = response.data.result.size_label;
            // this.$metaInfo.title = response.data.result.name;
            this.$store.state.list.breadcrumb = response.data.result.name;
            this.gender = response.data.result.gender;
            this.name = response.data.result.name;
            this.brand = response.data.result.brand;
            this.productURLkey = response.data.result.url_key;
            // this.meta_title = response.data.result.meta_title;
            // this.meta_description = response.data.result.meta_description;
            this.meta_keyword = response.data.result.meta_keyword;
            this.pro_id = response.data.result.id_product;
            this.$store.state.list.pro_id_store =
              response.data.result.id_product;
            this.shareImage = response.data.result.gallery[0].image;
            this.master_sku = response.data.result.sku;
            this.sub_group_id = response.data.result.sub_group_id;
            this.price = response.data.result.price;
            this.proNetQuantity = response.data.result.net_quantity;
            this.proDimenstion = response.data.result.dimensions || '';
            this.product_cat = response.data.result.category;
            this.productFeatuers = {
              f1: response.data.result.feature_1,
              f2: response.data.result.feature_2,
              f3: response.data.result.feature_3,
              f4: response.data.result.feature_4,
            }
            this.productStyleTip = response.data.result.style_tip
            this.selling_price = response.data.result.selling_price;
            this.quantity = response.data.result.quantity;
            this.productColor = response.data.result.colour;
            this.stock_status = response.data.result.stock_status;
            this.name_of_manufacturer =
              response.data.result.name_of_manufacturer;
            this.marketer_details = response.data.result.marketer_details
            this.manufacturer_name_address = response.data.result.manufacturer_name_address
            this.customer_complain = response.data.result.customer_complain;
            if (response.data.result.discount == "0") {
              this.is_discount = "no";
            } else {
              this.is_discount = "yes";
              this.getoffer();
            }

            this.description = response.data.result.description;
            this.placeholder_image = response.data.result.image;
            this.gallery = response.data.result.gallery;
            await this.get_review();
            this.sale = response.data.result.featured_tag;
            this.acces_return = response.data.result.accessories_block;
            this.galleryImages = this.gallery.map((x) => x.image);
            if (response.data.result.variation != null) {
              //    this.variation.concat(response.data.result.variation)
              this.variation = response.data.result.variation;
              if (Object.keys(this.variation).length == 1) {
                setTimeout(
                  () => document.querySelector(".select-one-size").click(),
                  100
                );
              }
            }

            if (response.data.result.color_options) {
              this.color_options = response.data.result.color_options;
            }
            if (response.data.result.size_chart) {
              this.size_guide = response.data.result.size_chart;
            }

            if (response.data.result.visible_attributes.length) {
              this.product_attr = [];
              for (
                let i = 0;
                i < response.data.result.visible_attributes.length;
                i++
              ) {
                if (
                  response.data.result.visible_attributes[i].code ===
                    "marked_by" ||
                  response.data.result.visible_attributes[i].code ===
                    "quantity_show" ||
                  response.data.result.visible_attributes[i].code ===
                    "name_of_manufacturer" ||
                  response.data.result.visible_attributes[i].code ===
                    "place_of_manufacturer" ||
                  response.data.result.visible_attributes[i].code ===
                    "registered_office_address" ||
                  response.data.result.visible_attributes[i].code ===
                    "manufactured_packed_for" ||
                  response.data.result.visible_attributes[i].code ===
                    "for_complaints"
                ) {
                  this.show_hide_product_attr.push(
                    response.data.result.visible_attributes[i]
                  );
                } else {
                  this.product_attr.push(
                    response.data.result.visible_attributes[i]
                  );
                }
                if (
                  response.data.result.visible_attributes[i].code ===
                  "style_coupon"
                ) {
                  this.offers_list =
                    response.data.result.visible_attributes[i].value;
                }
              }
            }

            if (param1) {
              this.$gtm.push({
                event: "ProductDetail",
                action: "Product Detail",
                ecommerce: {
                  detail: {
                    actionField: {
                      list: "list",
                      action: "detail",
                    },
                    product: [
                      {
                        name: this.name,
                        id: this.master_sku,
                        price: this.selling_price,
                        category: this.product_cat,
                        product_id: this.master_sku,
                        sub_group_id: this.sub_group_id,
                        original_product_price: this.selling_price,
                        product_category: this.product_cat,
                      },
                    ],
                  },
                },
              });
              this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
              this.$gtm.push({
                event: "select_item",
                ecommerce: {
                  items: [
                    {
                      item_id: this.sub_group_id,
                      item_subGId: this.sub_group_id,
                      item_name: this.name,
                      item_brand: this.brand,
                      item_productId: this.master_sku,
                      item_category: this.product_cat,
                      item_variant: this.productColor,
                      price: this.selling_price,
                      quantity: this.quantity,
                    },
                  ],
                },
              });

              this.$gtm.push({
                event: "view_item",
                ecommerce: {
                  currency: "INR",
                  value: this.selling_price,
                  items: [
                    {
                      item_id: this.sub_group_id,
                      item_subGId: this.sub_group_id,
                      item_name: this.name,
                      item_brand: this.brand,
                      item_productId: this.master_sku,
                      item_category: this.product_cat,
                      item_variant: this.productColor,
                      price: this.selling_price,
                      quantity: this.quantity,
                    },
                  ],
                },
              });
              if (this.callLightgallery) {
                setTimeout(
                  () =>
                    lightGallery(document.getElementById("lightgallery"), {
                      download: false,
                      closable: false,
                      selector: "img",
                    }),
                  100
                );
              }
            }

            //this.product_attr = response.data.result.visible_attributes;

            // if (response.data.result.size_chart) {
            //     this.size_guide = response.data.result.size_chart;
            // }
            if (response.data.result.similar_product_list) {
              this.team_up_products = response.data.result.similar_product_list;
            }
            this.$store.state.list.page_loader = false;
          } else {
            if (response.data.response.error_message === "no result") {
              return this.$router.push("/pagenotfound");
            } else {
              this.$toast.error(response.data.response.error_message, {
                position: "top",
                duration: 4000,
              });
            }
            this.$store.state.list.page_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$toast.error(
              "Oops there seems to be some Network issue, please try again.",
              {
                position: "top",
                duration: 4000,
              }
            );
          }
          this.$store.state.list.page_loader = false;
        });
    },
    add_to_cart: function (event) {
      if (this.$store.state.list.cart_product && this.$store.state.list.cart_product.length != 0) {
        var found = false;
        for (let i = 0; i < this.$store.state.list.cart_product.length; i++) {
          if (
            this.$store.state.list.cart_product[i].variant_id ==
            this.size.variant_id
          ) {
            // if (
            //   this.$store.state.list.cart_product[i].max_qty <=
            //   this.$store.state.list.cart_product[i].qty
            // ) {
            //   this.$toast.error(
            //     "Available quantity you have already added to your cart",
            //     {
            //       position: "top",
            //     }
            //   );
            //   found = true;
            //   break;
            // }
            if (this.$store.state.list.cart_product[i].qty == 1) {
              this.$toast.error(
                "Maximum quantity you have already added to your cart",
                {
                  position: "top",
                }
              );
              found = true;
              this.$store.state.page_loader = false;
              break;
            }
          }
        }
        if (found === false) {
          this.$store.state.list.cart_id = $cookies.get(
            window.location.hostname.substring(10, 4) + "_cart"
          );
          if (this.size.select_size != "") {
            this.$store.state.list.page_loader = true;
            var form = new FormData();
            form.append("product_id", this.size.variant_id);
            form.append("product_parent_id", this.pro_id);
            form.append("product_options", this.size.select_size);
            form.append("name", this.name);
            form.append("sku", this.size.sku);
            form.append("master_sku", this.master_sku);
            form.append("price", this.price);
            form.append("qty_ordered", this.qty);
            form.append("final_price", this.selling_price);
            form.append("store", this.$store.state.list.store);
            if (
              this.$store.state.list.cart_id != null &&
              this.$store.state.list.cart_id != ""
            ) {
              form.append("cart_id", this.$store.state.list.cart_id);
              form.append("cart_session", this.$store.state.list.cart_session);
            }
            if (this.$store.state.list.customer_session) {
              form.append("customer_id", this.$store.state.list.customer_id);
              form.append(
                "customer_session",
                this.$store.state.list.customer_session
              );
            }
            let config = { headers: { "Content-Type": "multipart/form-data" } };
            axios
              .post(
                this.$store.state.list.cart_api_url + "/product/add-product",
                form,
                config
              )
              .then((response) => {
                if (response.data.success === true) {
                  // gtag('event', 'add_to_cart', {
                  //     items: [
                  //         {
                  //         brand: this.brand,
                  //         variant: this.productColor,
                  //         // list_position: 1,
                  //         quantity: this.qty,
                  //         name: this.name,
                  //         id: this.master_sku,
                  //         price: this.selling_price,
                  //         category: this.product_cat,
                  //         }
                  //     ]
                  //     });
                  this.$toast.success(response.data.message, {
                    position: "top",
                    duration: 4000,
                  });
                  this.$store.state.list.error_message = "";
                  this.$store.state.list.page_loader = false;
                  this.$store.state.list.cart_product =
                    response.data.data.products;
                  //  this.$store.state.list.googleAnalyticsTag('add_to_cart')
                  this.$store.state.list.cart_total =
                    response.data.data.grand_total;
                  this.$store.state.list.cart_subtotal =
                    response.data.data.order_subtotal;
                  this.$store.state.list.discount_code =
                    response.data.data.discount_code;
                  this.$store.state.list.discount_amount =
                    response.data.data.discount_amount;
                  this.$store.state.list.address = response.data.data.address;
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    response.data.data.cart_id
                  );
                  this.$store.state.list.cart_id = response.data.data.cart_id;
                  this.$store.state.list.thankyou_cart =
                    response.data.data.cart_id;

                  if (response.data.data.cart_session) {
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_ct_sess",
                      response.data.data.cart_session,
                      "1y"
                    );
                    this.$store.state.list.cart_session =
                      response.data.data.cart_session;
                  }
                  if (this.$store.state.list.address.length != 0) {
                    for (
                      let i = 0;
                      i < this.$store.state.list.address.length;
                      i++
                    ) {
                      if (i == 0) {
                        this.$store.state.list.address_id =
                          this.$store.state.list.address[i].id * 1;
                        this.$store.state.list.select_address_no = i;
                      }
                    }
                  }

                  this.get_add_to_cart(response.data.data.cart_id);
                  if (event.target.title === "Buy now") {
                    this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    this.$gtm.push({
                      event: "add_to_cart",
                      ecommerce: {
                        currency: "INR",
                        value: this.selling_price,
                        items: [
                          {
                            item_id: this.sub_group_id,
                            item_subGId: this.sub_group_id,
                            item_name: this.name,
                            item_brand: this.brand,
                            item_productId: this.master_sku,
                            item_category: this.product_cat,
                            item_variant: this.size.select_size,
                            price: this.selling_price,
                            quantity: this.qty,
                          },
                        ],
                      },
                    });
                    setTimeout(() => {
                      this.$gtm.push({
                        event: "checkout",
                        action: "Buy_now",
                        ecommerce: {
                          checkout: {
                            actionField: {
                              step: 1,
                              option: this.$store.state.list.login_status,
                            },
                            product: this.$store.state.list.gtm_product,
                          },
                        },
                      });

                      this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                      this.$gtm.push({
                        event: "begin_checkout",
                        ecommerce: {
                          currency: "INR",
                          value: this.$store.state.list.summary.totalMRP,
                          items: this.$store.state.list.gtm_product_GA4,
                        },
                      });
                    }, 100);

                    this.$router.push("/checkout");
                  } else {
                    this.$store.state.list.minicart = false;
                    this.size_active = true;
                    this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    this.$gtm.push({
                      event: "add_to_cart",
                      ecommerce: {
                        currency: "INR",
                        value: this.selling_price,
                        items: [
                          {
                            item_id: this.sub_group_id,
                            item_subGId: this.sub_group_id,
                            item_name: this.name,
                            item_brand: this.brand,
                            item_productId: this.master_sku,
                            item_category: this.product_cat,
                            item_variant: this.size.select_size,
                            price: this.selling_price,
                            quantity: this.qty,
                          },
                        ],
                      },
                    });
                  }

                  this.size.select_size = "";
                } else {
                  this.$store.state.list.success_message = "";
                  this.$toast.error(response.data.message, {
                    position: "top",
                    duration: 4000,
                  });
                  this.$store.state.list.page_loader = false;
                  if (
                    response.data.cart_session_status == false ||
                    response.data.customer_session_status == false
                  ) {
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_customer",
                      "",
                      "1y"
                    );
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cus_sess",
                      "",
                      "1y"
                    );
                    this.$store.state.list.customer_id = "";
                    this.$store.state.list.customer_session = "";
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_cart",
                      "",
                      "1y"
                    );
                    $cookies.set(
                      window.location.hostname.substring(10, 4) + "_ct_sess",
                      "",
                      "1y"
                    );
                    this.$store.state.list.cart_id = "";
                    this.$store.state.list.cart_session = "";
                    this.$store.state.list.cart_product = [];
                  }
                }
              })
              .catch((error) => {
                this.$store.state.list.page_loader = false;
                if (error.message === "Network Error") {
                  this.$toast.error(
                    "Oops there seems to be some Network issue, please try again.",
                    {
                      position: "top",
                      duration: 4000,
                    }
                  );
                }
              });
          } else {
            this.size_active = false;

            this.size_error = "Please select a size first";
            this.vibrate();
            if (window.innerWidth > 767) {
              this.$toast.error("Please select a size first.", {
                position: "top",
                duration: 4000,
              });
            }
          }
        }
      } else {
        this.$store.state.list.cart_id = $cookies.get(
          window.location.hostname.substring(10, 4) + "_cart"
        );
        if (this.size.select_size != "") {
          this.$store.state.list.page_loader = true;
          var form = new FormData();
          form.append("product_id", this.size.variant_id);
          form.append("product_parent_id", this.pro_id);
          form.append("product_options", this.size.select_size);
          form.append("name", this.name);
          form.append("sku", this.size.sku);
          form.append("master_sku", this.master_sku);
          form.append("price", this.price);
          form.append("qty_ordered", this.qty);
          form.append("final_price", this.selling_price);
          form.append("store", this.$store.state.list.store);
          if (
            this.$store.state.list.cart_id != null &&
            this.$store.state.list.cart_id != ""
          ) {
            form.append("cart_id", this.$store.state.list.cart_id);
            form.append("cart_session", this.$store.state.list.cart_session);
          }
          if (
            this.$store.state.list.customer_id != null &&
            this.$store.state.list.customer_id != ""
          ) {
            form.append("customer_id", this.$store.state.list.customer_id);
            form.append(
              "customer_session",
              this.$store.state.list.customer_session
            );
          }
          let config = { headers: { "Content-Type": "multipart/form-data" } };
          axios
            .post(
              this.$store.state.list.cart_api_url + "/product/add-product",
              form,
              config
            )
            .then((response) => {
              if (response.data.success === true) {
                this.$toast.success(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                this.$store.state.list.error_message = "";
                this.$store.state.list.page_loader = false;
                this.$store.state.list.cart_product =
                  response.data.data.products;
                this.$store.state.list.cart_total =
                  response.data.data.grand_total;
                this.$store.state.list.cart_subtotal =
                  response.data.data.order_subtotal;
                this.$store.state.list.discount_code =
                  response.data.data.discount_code;
                this.$store.state.list.discount_amount =
                  response.data.data.discount_amount;
                this.$store.state.list.address = response.data.data.address;
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  response.data.data.cart_id
                );
                this.$store.state.list.cart_id = response.data.data.cart_id;
                this.$store.state.list.thankyou_cart =
                  response.data.data.cart_id;
                if (response.data.data.cart_session) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_ct_sess",
                    response.data.data.cart_session,
                    "1y"
                  );
                  this.$store.state.list.cart_session =
                    response.data.data.cart_session;
                }

                if (this.$store.state.list.address.length != 0) {
                  for (
                    let i = 0;
                    i < this.$store.state.list.address.length;
                    i++
                  ) {
                    if (i == 0) {
                      this.$store.state.list.address_id =
                        this.$store.state.list.address[i].id * 1;
                      this.$store.state.list.select_address_no = i;
                    }
                  }
                }
                this.get_add_to_cart(response.data.data.cart_id);
                if (event.target.title === "Buy now") {
                  this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                  this.$gtm.push({
                    event: "add_to_cart",
                    ecommerce: {
                      currency: "INR",
                      value: this.selling_price,
                      items: [
                        {
                          item_id: this.sub_group_id,
                          item_subGId: this.sub_group_id,
                          item_name: this.name,
                          item_brand: this.brand,
                          item_productId: this.master_sku,
                          item_category: this.product_cat,
                          item_variant: this.size.select_size,
                          price: this.selling_price,
                          quantity: this.qty,
                        },
                      ],
                    },
                  });
                  setTimeout(() => {
                    this.$gtm.push({
                      event: "checkout",
                      action: "Buy_now",
                      ecommerce: {
                        checkout: {
                          actionField: {
                            step: 1,
                            option: this.$store.state.list.login_status,
                          },
                          product: this.$store.state.list.gtm_product,
                        },
                      },
                    });
                    this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    this.$gtm.push({
                      event: "begin_checkout",
                      ecommerce: {
                        currency: "INR",
                        value: this.$store.state.list.summary.totalMRP,
                        items: this.$store.state.list.gtm_product_GA4,
                      },
                    });
                  }, 100);

                  this.$router.push("/checkout");
                } else {
                  this.$store.state.list.minicart = false;
                  this.size_active = true;
                  this.$gtm.push({ ecommerce: null }); // Clear the previous ecommerce object.
                  this.$gtm.push({
                    event: "add_to_cart",
                    ecommerce: {
                      currency: "INR",
                      value: this.selling_price,
                      items: [
                        {
                          item_id: this.sub_group_id,
                          item_subGId: this.sub_group_id,
                          item_name: this.name,
                          item_brand: this.brand,
                          item_productId: this.master_sku,
                          item_category: this.product_cat,
                          item_variant: this.size.select_size,
                          price: this.selling_price,
                          quantity: this.qty,
                        },
                      ],
                    },
                  });
                }
                this.size.select_size = "";
              } else {
                this.$store.state.list.success_message = "";
                this.$toast.error(response.data.message, {
                  position: "top",
                  duration: 4000,
                });
                this.$store.state.list.page_loader = false;
                if (
                  response.data.cart_session_status == false ||
                  response.data.customer_session_status == false
                ) {
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_customer",
                    "",
                    "1y"
                  );
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cus_sess",
                    "",
                    "1y"
                  );
                  this.$store.state.list.customer_id = "";
                  this.$store.state.list.customer_session = "";
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_cart",
                    "",
                    "1y"
                  );
                  $cookies.set(
                    window.location.hostname.substring(10, 4) + "_ct_sess",
                    "",
                    "1y"
                  );
                  this.$store.state.list.cart_id = "";
                  this.$store.state.list.cart_session = "";
                  this.$store.state.list.cart_product = [];
                }
              }
            })
            .catch((error) => {
              this.$store.state.list.page_loader = false;
              if (error.message === "Network Error") {
                this.$toast.error(
                  "Oops there seems to be some Network issue, please try again.",
                  {
                    position: "top",
                    duration: 4000,
                  }
                );
              }
            });
        } else {
          this.size_active = false;
          this.size_error = "Please select a size first";
          this.vibrate();
          if (window.innerWidth > 767) {
            this.$toast.error("Please select a size first.", {
              position: "top",
              duration: 4000,
            });
          }
        }
      }
    },
    select_size: function (item) {
      this.clicked = true;
      this.size_error = "";
      this.qty = "1";
      this.selectProduct(item);
    },
    size_close: function () {
      this.size_active = true;
    },
    openModel() {
      alert("ii");
      this.openGallary = true;
    },
    get_wish() {
      var form = new FormData();
      form.append("customer_id", this.$store.state.list.customer_id);
      form.append("customer_session", this.$store.state.list.customer_session);
      axios
        .post(
          this.$store.state.list.cart_api_url + `/wishlist/customer-wishlist`,
          form
        )
        .then((response) => {
          if (response.data.success == true) {
            //this.$store.state.list.wishpro=response.data.data.product.split(',');
            this.wishlist = response.data.data.product?.split(",");
            this.$store.state.list.wishlist_count =
              response.data.data.total_row;
          }
        });
    },
    getoffer() {
      var form = new FormData();
      form.append("sku", this.master_sku);
      form.append("is_discount", this.is_discount);
      axios
        .post(this.$store.state.list.cart_api_url + `/cart/coupon`, form)
        .then((response) => {
          if (response.data.success == true) {
            this.couponoffers = response.data.data;
          }
        });
    },
    add_w(id) {
      if (
        this.$store.state.list.customer_id != "" &&
        this.$store.state.list.customer_id != null
      ) {
        this.$store.state.list.page_loader = true;
        var form = new FormData();
        form.append("product_id", id);
        form.append("customer_id", this.$store.state.list.customer_id);
        form.append(
          "customer_session",
          this.$store.state.list.customer_session
        );
        axios
          .post(
            this.$store.state.list.cart_api_url + `/wishlist/add-wishlist`,
            form
          )
          .then((response) => {
            this.$store.state.list.page_loader = false;
            if (response.data.success == true) {
              //this.$store.state.list.wishlist = response.data.data.product;
              this.wishlist = response.data.data.product.split(",");
              this.$store.state.list.wishlist =
                response.data.data.product?.split(",");
              this.$store.state.list.wishlist_count =
                response.data.data.total_row;
              //this.wishlist = true;
              this.variationId();
              this.$toast.success(response.data.message, {
                position: "top-right",
                duration: 4000,
              });
            } else {
              this.$store.state.list.page_loader = false;
              if (response.data.data.customer_session_status == false) {
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_customer",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cus_sess",
                  "",
                  "1y"
                );
                this.$store.state.list.customer_id = "";
                this.$store.state.list.customer_session = "";
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_cart",
                  "",
                  "1y"
                );
                $cookies.set(
                  window.location.hostname.substring(10, 4) + "_ct_sess",
                  "",
                  "1y"
                );
                this.$store.state.list.cart_id = "";
                this.$store.state.list.cart_session = "";
                this.$store.state.list.cart_product = [];
              }
            }
          });
      } else {
        this.$store.state.list.login_popup = true;
      }
    },
    remove_w(id) {
      this.$store.state.list.page_loader = true;
      var form = new FormData();
      form.append("product_id", id);
      form.append("customer_id", this.$store.state.list.customer_id);
      form.append("customer_session", this.$store.state.list.customer_session);
      axios
        .post(
          this.$store.state.list.cart_api_url + `/wishlist/remove-wishlist`,
          form
        )
        .then((response) => {
          if (response.data.success == true) {
            this.$store.state.list.page_loader = false;
            if (response.data.data.product) {
              this.wishlist = response.data.data.product.split(",");
              this.$store.state.list.wishlist =
                response.data.data.product?.split(",");
              this.$store.state.list.wishlist_count =
                response.data.data.total_row;
              this.variationId();
            } else {
              this.$store.state.list.wishlist_count = "0";
              this.$store.state.list.wishlist = [];
              this.wishDatapr = false;
              this.wishlist = [];
            }
            this.$toast.success(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
          } else {
            this.$store.state.list.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cus_sess",
                "",
                "1y"
              );
              this.$store.state.list.customer_id = "";
              this.$store.state.list.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_ct_sess",
                "",
                "1y"
              );
              this.$store.state.list.cart_id = "";
              this.$store.state.list.cart_session = "";
              this.$store.state.list.cart_product = [];
            }
          }
        });
    },
    wishActive: function (wish) {
      return this.wishlist.indexOf(wish) > -1;
    },
    truncate(value) {
      if (value.length >= 50) {
        return value.substring(0, 50) + "...";
      } else {
        return value;
      }
    },
  },
  computed: {
    coupen_list_one() {
      let y = this.coupon_list.slice(0, 1);
      return y;
    },
    pincode_success_new: {
      get: function () {
        return '<span class="span1">Free Delivery on items above Rs. 799</span><span class="span4">15 days free returns.</span>';
      },
      set: function (newValue) {
        //return newValue
        this.pincode_success = newValue;
      },
    },
  },
  async fetch() {
    this.$store.state.list.error_message = "";
    this.$store.state.list.success_message = "";
    this.$store.state.list.page_loader = false;
    await this.getprodetail(false);
  },
  created() {
    this.similarproduct();
    this.coupon_lists();
    this.callLightgallery = true;
  },
  async mounted() {
    setTimeout(() => {
      this.getCasaProductView();
    }, 300);

    window.scrollTo(0, 0);
    await this.getprodetail(true);
    // if (
    //   this.$store.state.list.customer_id != "" &&
    //   this.$store.state.list.customer_id != null
    // ) {
    //   this.get_wish();
    // }

    // this.$store.state.list.error_message = '',
    //     this.$store.state.list.success_message = '',
    //     this.$store.state.list.page_loader = false;
    // this.getprodetail();

    // this.pincode = $cookies.get(
    //   window.location.hostname.substring(10, 4) + "_pin"
    // );
    // if (this.pincode != "" && this.pincode != null) {
    //   this.pin_code();
    // }
    this.variationId();
  },
  updated() {
    jQuery(".size_tt").click(function () {
      if (!jQuery(this).hasClass("active")) {
        jQuery(".size_img").removeClass("active");
        jQuery(".size_tt").addClass("active");
        jQuery(".size_guide_container").animate(
          { scrollTop: jQuery(".sizechart_table").position().top - 60 },
          "slow"
        );
      }
    });
    jQuery(".size_img").click(function () {
      if (!jQuery(this).hasClass("active")) {
        jQuery(".size_tt").removeClass("active");
        jQuery(".size_img").addClass("active");
        jQuery(".size_guide_container").animate(
          { scrollTop: jQuery(".sizechart_measure_img").position().top - 60 },
          "slow"
        );
      }
    });
    setTimeout(
      () =>
        lightGallery(document.getElementById("lightgallery"), {
          download: false,
          closable: false,
          selector: "img",
        }),
      100
    );
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
};
